import React, { useRef, useEffect } from 'react';

import {
  FormControl,
  FormHelperText,
  FormLabel,
  RadioGroup as RadioGroupUI,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
import { useField } from '@unform/core';
import { isEqual, isUndefined } from 'lodash';
import PropTypes from 'prop-types';

import { canURL } from '~/helpers';

function RadioGroup({
  name,
  options,
  label,
  disabled,
  serialize,
  getValue,
  ...rest
}) {
  const inputRef = useRef(null);
  const permission = isEqual(canURL(), { read: true });

  const { fieldName, defaultValue, registerField, error } = useField(name);

  function handleChangeValue(event) {
    const { value } = event.target;
    inputRef.current.value = serialize(value);
    getValue(value);
  }

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  useEffect(() => {
    if (isUndefined(inputRef.current.value) || !inputRef.current.value) {
      if (defaultValue) {
        inputRef.current.value = serialize(defaultValue);
        getValue(defaultValue);
      } else if (rest.defaultValue) {
        inputRef.current.value = serialize(rest.defaultValue);
        getValue(rest.defaultValue);
      }
    }
  }, [defaultValue, rest]);

  return (
    <FormControl style={{ width: '100%' }} component="fieldset">
      <FormLabel component="legend" style={{ fontSize: '1.2rem' }}>
        {label}
      </FormLabel>

      <RadioGroupUI
        onChange={handleChangeValue}
        defaultValue={defaultValue}
        ref={inputRef}
        size="small"
        {...rest}
        disabled={permission || disabled}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={
              <Radio
                color="primary"
                size="small"
                disabled={permission || disabled}
              />
            }
            label={option.label}
          />
        ))}
      </RadioGroupUI>

      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
}

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  serialize: PropTypes.func,
  getValue: PropTypes.func,
};

RadioGroup.defaultProps = {
  disabled: false,
  serialize: (value) => value,
  getValue: () => undefined,
};

export default RadioGroup;
